// Authentic Tamil (தமிழ்) translations for every term & label on the Panchangam page.
// Keys mirror the romanised-Sanskrit names returned by the live ephemeris API
// (same keys as panchangMaps.js) so the page can resolve Tamil from any field's
// English slot. Admins can override ANY value (English / Hindi / Tamil) from
// Admin → Panchangam Editor (stored in site_settings.panchang_tamil as per-field
// { en?, hi?, ta? } objects; a legacy plain string is treated as Tamil).
import { TITHI, NAKSHATRA, YOGA, KARANA, RASHI, VARA, PAKSHA } from "@/lib/panchangMaps";

export const TA_TITHI = {
  Pratipada: "பிரதமை", Dwitiya: "துவிதியை", Tritiya: "திருதியை", Chaturthi: "சதுர்த்தி",
  Panchami: "பஞ்சமி", Shashthi: "சஷ்டி", Saptami: "சப்தமி", Ashtami: "அஷ்டமி",
  Navami: "நவமி", Dashami: "தசமி", Ekadashi: "ஏகாதசி", Dwadashi: "துவாதசி",
  Trayodashi: "திரயோதசி", Chaturdashi: "சதுர்த்தசி", Purnima: "பௌர்ணமி", Amavasya: "அமாவாசை",
};

export const TA_PAKSHA = { Shukla: "வளர்பிறை", Krishna: "தேய்பிறை" };

export const TA_NAKSHATRA = {
  Ashwini: "அசுவினி", Bharani: "பரணி", Krittika: "கார்த்திகை", Rohini: "ரோகிணி",
  Mrigashira: "மிருகசீரிடம்", Mrigashirsha: "மிருகசீரிடம்", Ardra: "திருவாதிரை", Punarvasu: "புனர்பூசம்",
  Pushya: "பூசம்", Ashlesha: "ஆயில்யம்", Magha: "மகம்",
  "Purva Phalguni": "பூரம்", "Poorva Phalguni": "பூரம்", "Uttara Phalguni": "உத்தரம்",
  Hasta: "அஸ்தம்", Chitra: "சித்திரை", Swati: "சுவாதி", Swathi: "சுவாதி", Vishakha: "விசாகம்",
  Anuradha: "அனுஷம்", Jyeshtha: "கேட்டை", Jyeshta: "கேட்டை", Mula: "மூலம்", Moola: "மூலம்",
  "Purva Ashadha": "பூராடம்", "Poorva Ashadha": "பூராடம்", "Uttara Ashadha": "உத்திராடம்",
  Shravana: "திருவோணம்", Dhanishta: "அவிட்டம்", Shatabhisha: "சதயம்", Shatabhishak: "சதயம்",
  "Purva Bhadrapada": "பூரட்டாதி", "Poorva Bhadrapada": "பூரட்டாதி", "Uttara Bhadrapada": "உத்திரட்டாதி", Revati: "ரேவதி",
};

export const TA_YOGA = {
  Vishkambha: "விஷ்கம்பம்", Priti: "ப்ரீதி", Ayushman: "ஆயுஷ்மான்", Saubhagya: "சௌபாக்கியம்",
  Shobhana: "சோபனம்", Atiganda: "அதிகண்டம்", Sukarma: "சுகர்மா", Sukarman: "சுகர்மா", Dhriti: "திருதி",
  Shula: "சூலம்", Ganda: "கண்டம்", Vriddhi: "விருத்தி", Dhruva: "துருவம்", Vyaghata: "வியாகாதம்",
  Harshana: "ஹர்ஷணம்", Vajra: "வஜ்ரம்", Siddhi: "சித்தி", Vyatipata: "வியதீபாதம்",
  Variyana: "வரியான்", Variyan: "வரியான்", Parigha: "பரிகம்", Shiva: "சிவம்", Siddha: "சித்தம்",
  Sadhya: "சாத்தியம்", Shubha: "சுபம்", Shukla: "சுக்லம்", Brahma: "பிரம்மம்", Indra: "ஐந்திரம்",
  Aindra: "ஐந்திரம்", Vaidhriti: "வைதிருதி",
};

export const TA_KARANA = {
  Bava: "பவம்", Balava: "பாலவம்", Kaulava: "கௌலவம்", Taitila: "தைதிலம்", Gara: "கரஜம்", Garaja: "கரஜம்",
  Vanija: "வணிஜம்", Vishti: "விஷ்டி", Bhadra: "விஷ்டி", Shakuni: "சகுனி", Sakuni: "சகுனி",
  Chatushpada: "சதுஷ்பாதம்", Chatushpad: "சதுஷ்பாதம்", Naga: "நாகம்", Kimstughna: "கிம்ஸ்துக்னம்", Kintughna: "கிம்ஸ்துக்னம்",
};

export const TA_RASHI = {
  Mesha: "மேஷம்", Vrishabha: "ரிஷபம்", Vrisha: "ரிஷபம்", Mithuna: "மிதுனம்", Karka: "கடகம்", Kark: "கடகம்",
  Simha: "சிம்மம்", Kanya: "கன்னி", Tula: "துலாம்", Vrishchika: "விருச்சிகம்", Vrischika: "விருச்சிகம்",
  Dhanu: "தனுசு", Dhanus: "தனுசு", Makara: "மகரம்", Makar: "மகரம்", Kumbha: "கும்பம்", Meena: "மீனம்", Mina: "மீனம்",
};

export const TA_VARA = {
  Ravivara: "ஞாயிற்றுக்கிழமை", Somavara: "திங்கட்கிழமை", Mangalavara: "செவ்வாய்க்கிழமை", Budhavara: "புதன்கிழமை",
  Guruvara: "வியாழக்கிழமை", Brihaspativara: "வியாழக்கிழமை", Shukravara: "வெள்ளிக்கிழமை", Shanivara: "சனிக்கிழமை",
};

// Lunar months (chandra masa) — transliterated Sanskrit month names as used in
// Tamil panchangam. Admins may change these to Tamil solar-month names if preferred.
export const TA_MASA = {
  Chaitra: "சைத்ரம்", Vaishakha: "வைசாகம்", Vaisakha: "வைசாகம்", Jyeshtha: "ஜ்யேஷ்டம்", Jyaistha: "ஜ்யேஷ்டம்",
  Ashadha: "ஆஷாடம்", Ashadh: "ஆஷாடம்", Shravana: "ஸ்ரவணம்", Shraavana: "ஸ்ரவணம்",
  Bhadrapada: "பாத்ரபதம்", Bhaadrapada: "பாத்ரபதம்", Ashwin: "ஆஸ்வினம்", Ashwina: "ஆஸ்வினம்", Ashvin: "ஆஸ்வினம்",
  Kartika: "கார்த்திகம்", Kartik: "கார்த்திகம்", Margashirsha: "மார்கசீர்ஷம்", Margashira: "மார்கசீர்ஷம்",
  Pausha: "பௌஷம்", Paush: "பௌஷம்", Magha: "மாகம்", Maagha: "மாகம்", Phalguna: "பால்குனம்", Phalgun: "பால்குனம்",
};

// Seasons (ritu).
export const TA_RITU = {
  Vasanta: "வசந்தம்", Grishma: "கிரீஷ்மம்", Greeshma: "கிரீஷ்மம்", Varsha: "வர்ஷம்",
  Sharad: "சரத்", Sharada: "சரத்", Hemanta: "ஹேமந்தம்", Shishira: "சிசிரம்", Sisira: "சிசிரம்",
};

// Presiding deities (vara/tithi/nakshatra devatas + parenthetical epithets).
export const TA_DEITY = {
  Surya: "சூரியன்", Shiva: "சிவன்", Hanuman: "அனுமன்", Vishnu: "விஷ்ணு", Brihaspati: "குரு",
  Lakshmi: "லக்ஷ்மி", Shani: "சனி", Agni: "அக்னி", Brahma: "பிரம்மா", Gauri: "கௌரி",
  Ganesha: "விநாயகர்", Ganesh: "விநாயகர்", Naga: "நாகம்", Nagas: "நாகங்கள்", Kartikeya: "முருகன்",
  Durga: "துர்க்கை", Yama: "யமன்", Vishvedeva: "விஸ்வேதேவர்", Vishvedevas: "விஸ்வேதேவர்கள்", Vishwedevas: "விஸ்வேதேவர்கள்",
  Kamadeva: "மன்மதன்", Chandra: "சந்திரன்", Soma: "சந்திரன்", Moon: "சந்திரன்", Pitru: "பித்ருக்கள்", Pitris: "பித்ருக்கள்",
  "Ashvini Kumaras": "அசுவினி தேவர்கள்", "Ashwini Kumaras": "அசுவினி தேவர்கள்", Ashvini: "அசுவினி தேவர்கள்", Ashwini: "அசுவினி தேவர்கள்",
  Prajapati: "பிரஜாபதி", Rudra: "ருத்திரன்", Aditi: "அதிதி", Sarpas: "நாகங்கள்", Bhaga: "பகன்", Aryaman: "அர்யமன்",
  Savitr: "சவிதா", Savita: "சவிதா", Tvastar: "விஸ்வகர்மா", Tvashtar: "விஸ்வகர்மா", Vishvakarma: "விஸ்வகர்மா", Vishwakarma: "விஸ்வகர்மா",
  Vayu: "வாயு", Mitra: "மித்ரன்", Indra: "இந்திரன்", Indrani: "இந்திராணி", Nirriti: "நிருதி", Apah: "ஜலம்", Apas: "ஜலம்", Water: "ஜலம்",
  Varuna: "வருணன்", Pushan: "பூஷன்", Vasu: "வசு", Vasus: "வசுக்கள்", "Aja Ekapada": "அஜ ஏகபாதம்", AjaEkapada: "அஜ ஏகபாதம்",
  "Ahir Budhnya": "அஹிர்புத்னியன்", Ahirbudhnya: "அஹிர்புத்னியன்", "Ahirbudhnya": "அஹிர்புத்னியன்",
  Bhumi: "பூமாதேவி", Skanda: "முருகன்", Narayana: "நாராயணன்", Savitri: "சாவித்ரி",
  Vidhatri: "பிரம்மா", Vidhata: "பிரம்மா", Dhata: "தாதா", Dharma: "தர்மன்", Aditya: "ஆதித்யன்",
  Matri: "மாத்ரு தேவியர்", Matrika: "மாத்ரு தேவியர்", Hari: "விஷ்ணு", Kali: "காளி", Ahi: "நாகம்", Guha: "முருகன்",
  Ashvins: "அசுவினி தேவர்கள்", Vishwakarma: "விஸ்வகர்மா",
};

// Hora (planetary hour) — keyed by the romanised-Sanskrit name the API sends in `display`.
export const TA_HORA = {
  Surya: "சூரியன்", Chandra: "சந்திரன்", Mangala: "செவ்வாய்", Budha: "புதன்",
  Guru: "குரு", Shukra: "சுக்கிரன்", Shani: "சனி",
  // English planet fallbacks
  Sun: "சூரியன்", Moon: "சந்திரன்", Mars: "செவ்வாய்", Mercury: "புதன்", Jupiter: "குரு", Venus: "சுக்கிரன்", Saturn: "சனி",
};

// Short descriptor for each hora, keyed by the romanised-Sanskrit / English planet name.
export const TA_HORA_NOTE = {
  Surya: "அதிகாரம், ஆரோக்கியம், அரசாங்கம்", Sun: "அதிகாரம், ஆரோக்கியம், அரசாங்கம்",
  Chandra: "பயணம், உணர்வுகள், நீர், இல்லம்", Moon: "பயணம், உணர்வுகள், நீர், இல்லம்",
  Mangala: "ஆற்றல், தைரியம், தகராறு", Mars: "ஆற்றல், தைரியம், தகராறு",
  Budha: "கல்வி, வர்த்தகம், தொடர்பு", Mercury: "கல்வி, வர்த்தகம், தொடர்பு",
  Guru: "ஞானம், சடங்குகள், செல்வம்", Jupiter: "ஞானம், சடங்குகள், செல்வம்",
  Shukra: "கலை, அன்பு, செழிப்பு", Venus: "கலை, அன்பு, செழிப்பு",
  Shani: "உழைப்பு, ஒழுக்கம், தாமதம்", Saturn: "உழைப்பு, ஒழுக்கம், தாமதம்",
};

// Hindi (Devanagari) hora descriptors.
export const HI_HORA_NOTE = {
  Surya: "अधिकार, स्वास्थ्य, शासन", Sun: "अधिकार, स्वास्थ्य, शासन",
  Chandra: "यात्रा, भावनाएँ, जल, गृह", Moon: "यात्रा, भावनाएँ, जल, गृह",
  Mangala: "ऊर्जा, साहस, विवाद", Mars: "ऊर्जा, साहस, विवाद",
  Budha: "शिक्षा, व्यापार, संवाद", Mercury: "शिक्षा, व्यापार, संवाद",
  Guru: "ज्ञान, अनुष्ठान, समृद्धि", Jupiter: "ज्ञान, अनुष्ठान, समृद्धि",
  Shukra: "कला, प्रेम, वैभव", Venus: "कला, प्रेम, वैभव",
  Shani: "श्रम, अनुशासन, विलंब", Saturn: "श्रम, अनुशासन, विलंब",
};

// UI labels — each carries English, Hindi and Tamil so the page toggle can render
// any of the three from a single source. `hi` mirrors the copy already on the page.
export const TA_UI = {
  daily_almanac: { en: "Daily Almanac", hi: "दैनिक पंचांग", ta: "தினசரி பஞ்சாங்கம்" },
  panchanga: { en: "Panchangam", hi: "पंचांग", ta: "பஞ்சாங்கம்" },
  compute_note: {
    en: "Computed astronomically (Swiss Ephemeris / True Lahiri Ayanamsa) using strict Geometric Center-Disc sunrise with zero atmospheric refraction. Unlike commercial apps that rely on apparent optical sunrise, Dharmartha Panchangam uses the classical Siddhantic approach to eliminate atmospheric distortion, resulting in a highly precise ~3-4 minute variance in Sunrise, Sunset, Horas and Muhurtas.",
    hi: "खगोलीय रूप से परिकलित (Swiss Ephemeris / True Lahiri Ayanamsa) — शून्य वायुमंडलीय अपवर्तन के साथ कठोर ज्यामितीय केंद्र-बिम्ब सूर्योदय का प्रयोग। आभासी प्रकाशीय सूर्योदय पर निर्भर वाणिज्यिक ऐप्स के विपरीत, धर्मार्थ पंचांग शास्त्रीय सैद्धान्तिक पद्धति अपनाता है जिससे वायुमंडलीय विकृति समाप्त हो जाती है — फलतः सूर्योदय, सूर्यास्त, होरा एवं मुहूर्त में अत्यन्त सूक्ष्म ~3–4 मिनट का अन्तर।",
    ta: "வானியல் அடிப்படையில் கணிக்கப்பட்டது (Swiss Ephemeris / True Lahiri Ayanamsa) — பூஜ்ஜிய வளிமண்டல ஒளிவிலகலுடன் கடுமையான வடிவியல் மைய-வட்ட சூரிய உதயத்தைப் பயன்படுத்துகிறது. தோற்ற ஒளியியல் சூரிய உதயத்தை நம்பியிருக்கும் வணிகச் செயலிகளைப் போலன்றி, தர்மார்த்த பஞ்சாங்கம் பாரம்பரிய சித்தாந்த முறையைப் பயன்படுத்தி வளிமண்டல சிதைவை நீக்குகிறது — இதனால் சூரிய உதயம், அஸ்தமனம், ஹோரை மற்றும் முகூர்த்தங்களில் மிகத் துல்லியமான ~3–4 நிமிட வேறுபாடு.",
  },
  ayanamsa: { en: "Ayanamsa", hi: "अयनांश", ta: "அயனாம்சம்" },
  hero_subtitle: {
    en: "The five limbs of Vedic time — Tithi, Vara, Nakshatra, Yoga and Karana. Real-time transition moments, planetary horas and auspicious muhurtas calculated for your exact location.",
    hi: "वैदिक काल के पाँच अंग — तिथि, वार, नक्षत्र, योग एवं करण। आपके ठीक स्थान हेतु परिकलित संक्रमण-क्षण, ग्रह-होरा एवं शुभ मुहूर्त।",
    ta: "வேத காலத்தின் ஐந்து அங்கங்கள் — திதி, வாரம், நட்சத்திரம், யோகம் மற்றும் கரணம். உங்கள் சரியான இடத்திற்கான நிகழ்நேர மாற்றத் தருணங்கள், கிரக ஹோரைகள் மற்றும் நல்ல முகூர்த்தங்கள் கணக்கிடப்படுகின்றன.",
  },
  date: { en: "Date", hi: "तिथि", ta: "தேதி" },
  time: { en: "Time", hi: "समय", ta: "நேரம்" },
  now: { en: "Now", hi: "अभी", ta: "இப்போது" },
  location: { en: "Location", hi: "स्थान", ta: "இடம்" },
  paksha: { en: "Paksha", hi: "पक्ष", ta: "பக்ஷம்" },
  pitru_paksha: { en: "Pitru Paksha", hi: "पितृ पक्ष", ta: "பித்ரு பக்ஷம்" },
  open_guide: { en: "Open the guide", hi: "मार्गदर्शिका", ta: "வழிகாட்டியைத் திற" },
  current_hora: { en: "Current Hora", hi: "वर्तमान होरा", ta: "தற்போதைய ஹோரை" },
  day: { en: "day", hi: "दिन", ta: "பகல்" },
  night: { en: "night", hi: "रात्रि", ta: "இரவு" },
  windows_heading: { en: "Auspicious & Inauspicious Windows", hi: "शुभ एवं अशुभ काल", ta: "நல்ல மற்றும் தீய நேரங்கள்" },
  brahma: { en: "Brahma Muhurta", hi: "ब्रह्म मुहूर्त", ta: "பிரம்ம முகூர்த்தம்" },
  brahma_tip: { en: "The best time to wake up and meditate", hi: "जागने एवं ध्यान का सर्वोत्तम समय", ta: "எழுந்து தியானிக்க சிறந்த நேரம்" },
  abhijit: { en: "Abhijit Muhurta", hi: "अभिजित मुहूर्त", ta: "அபிஜித் முகூர்த்தம்" },
  rahu: { en: "Rahu Kalam", hi: "राहु काल", ta: "ராகு காலம்" },
  yama: { en: "Yama Gandam", hi: "यम गण्ड", ta: "யமகண்டம்" },
  gulika: { en: "Gulika Kalam", hi: "गुलिक काल", ta: "குளிகை காலம்" },
  vara: { en: "Vara", hi: "वार", ta: "வாரம்" },
  tithi: { en: "Tithi", hi: "तिथि", ta: "திதி" },
  nakshatra: { en: "Nakshatra", hi: "नक्षत्र", ta: "நட்சத்திரம்" },
  yoga: { en: "Yoga", hi: "योग", ta: "யோகம்" },
  karana: { en: "Karana", hi: "करण", ta: "கரணம்" },
  lunar_month: { en: "Lunar Month", hi: "चान्द्र मास", ta: "சந்திர மாதம்" },
  amanta: { en: "Amanta", hi: "अमान्त", ta: "அமாந்தம்" },
  purnimanta: { en: "Purnimanta", hi: "पूर्णिमान्त", ta: "பூர்ணிமாந்தம்" },
  moon: { en: "Moon", hi: "चन्द्र", ta: "சந்திரன்" },
  sun: { en: "Sun", hi: "सूर्य", ta: "சூரியன்" },
  rashi: { en: "Rashi", hi: "राशि", ta: "ராசி" },
  moonrise: { en: "Moonrise", hi: "चन्द्रोदय", ta: "சந்திர உதயம்" },
  moonset: { en: "Moonset", hi: "चन्द्रास्त", ta: "சந்திர அஸ்தமனம்" },
  sunrise: { en: "Sunrise", hi: "सूर्योदय", ta: "சூரிய உதயம்" },
  sunset: { en: "Sunset", hi: "सूर्यास्त", ta: "சூரிய அஸ்தமனம்" },
  moon_length: { en: "Moon length", hi: "चन्द्रमान", ta: "நிலவு நேரம்" },
  day_length: { en: "Day length", hi: "दिनमान", ta: "பகல் நேரம்" },
  ritu: { en: "Ritu", hi: "ऋतु", ta: "ருது" },
  samvat: { en: "Samvat", hi: "संवत्", ta: "சம்வத்" },
  vikram: { en: "Vikram", hi: "विक्रम", ta: "விக்ரமம்" },
  shaka: { en: "Shaka", hi: "शक", ta: "சகம்" },
  hora_timeline: { en: "Hora Timeline", hi: "होरा समय-सारणी", ta: "ஹோரை கால அட்டவணை" },
  hora_timeline_sub: {
    en: "The 24 planetary hours from sunrise to next sunrise. Plan important tasks in favourable horas.",
    hi: "सूर्योदय से अगले सूर्योदय तक 24 ग्रह-होरा। शुभ होरा में महत्त्वपूर्ण कार्य करें।",
    ta: "சூரிய உதயத்திலிருந்து அடுத்த சூரிய உதயம் வரை 24 கிரக ஹோரைகள். சாதகமான ஹோரையில் முக்கியப் பணிகளைச் செய்யுங்கள்.",
  },
  q_strong: { en: "Strong", hi: "श्रेष्ठ", ta: "வலுவான" },
  q_favourable: { en: "Favourable", hi: "अनुकूल", ta: "சாதகமான" },
  q_alert: { en: "Alert", hi: "सतर्कता", ta: "எச்சரிக்கை" },
  q_caution: { en: "Caution", hi: "सावधानी", ta: "ஜாக்கிரதை" },
  day_part: { en: "Day (sunrise → sunset)", hi: "दिन (सूर्योदय से सूर्यास्त)", ta: "பகல் (சூரிய உதயம் → அஸ்தமனம்)" },
  night_part: { en: "Night (sunset → sunrise)", hi: "रात्रि (सूर्यास्त से सूर्योदय)", ta: "இரவு (அஸ்தமனம் → சூரிய உதயம்)" },
  choghadiya: { en: "Choghadiya Muhurta", hi: "चौघड़िया मुहूर्त", ta: "சௌகடியா முகூர்த்தம்" },
  choghadiya_sub: {
    en: "Eight day and eight night choghadiyas. Prefer Shubh, Amrit, Labh and Char for important work.",
    hi: "दिन एवं रात्रि के आठ-आठ चौघड़िया। शुभ, अमृत, लाभ एवं चर काल में महत्त्वपूर्ण कार्य करें।",
    ta: "பகல் எட்டு, இரவு எட்டு சௌகடியாக்கள். முக்கியப் பணிகளுக்கு சுப, அமிர்த, லாப மற்றும் சர காலங்களை விரும்புங்கள்.",
  },
  day_choghadiya: { en: "Day Choghadiya", hi: "दिन का चौघड़िया", ta: "பகல் சௌகடியா" },
  night_choghadiya: { en: "Night Choghadiya", hi: "रात्रि का चौघड़िया", ta: "இரவு சௌகடியா" },
  devata: { en: "Devata", hi: "देवता", ta: "தேவதை" },
  next: { en: "Next", hi: "अगला", ta: "அடுத்து" },
  pada: { en: "Pada", hi: "पाद", ta: "பாதம்" },
  now_badge: { en: "Now", hi: "अभी", ta: "இப்போது" },
  marked_dates: { en: "Marked special dates", hi: "चिह्नित विशेष तिथियाँ", ta: "குறிக்கப்பட்ட சிறப்பு நாட்கள்" },
  polar_notice: {
    en: "Midnight sun / polar night — at this extreme latitude, sunrise-based timings (Choghadiya, Hora, Muhurta) are approximate.",
    hi: "ध्रुवीय क्षेत्र — मध्यरात्रि सूर्य / ध्रुवीय रात्रि के कारण सूर्योदय-आधारित समय (चौघड़िया, होरा, मुहूर्त) अनुमानित हैं।",
    ta: "நள்ளிரவு சூரியன் / துருவ இரவு — இந்த உயர் அட்சரேகையில் சூரிய உதயத்தை அடிப்படையாகக் கொண்ட நேரங்கள் (சௌகடியா, ஹோரை, முகூர்த்தம்) தோராயமானவை.",
  },
  premium_almanac: { en: "Scriptural Almanac", hi: "शास्त्रीय पंचांग", ta: "சாத்திர பஞ்சாங்கம்" },
  premium_almanac_sub: { en: "Festival muhurtas, scriptural karmakala windows, Varjyam and Siddhi yogas — sourced from the classical nibandha texts.", hi: "पर्व मुहूर्त, शास्त्रीय कर्मकाल, वर्ज्यम् एवं सिद्धि योग — शास्त्रीय निबन्ध ग्रन्थों से।", ta: "பண்டிகை முகூர்த்தங்கள், சாத்திர கர்மகால நேரங்கள், வர்ஜியம் மற்றும் சித்தி யோகங்கள் — பாரம்பரிய நூல்களிலிருந்து." },
  festival_hub: { en: "Festival & Puja Windows", hi: "पर्व एवं पूजा काल", ta: "பண்டிகை மற்றும் பூஜை நேரங்கள்" },
  no_pujas: { en: "No special festival rites listed for this date.", hi: "इस तिथि हेतु कोई विशेष पर्व-कर्म सूचीबद्ध नहीं।", ta: "இந்த தேதிக்கு சிறப்பு பண்டிகை சடங்குகள் எதுவும் இல்லை." },
  karmakala: { en: "Scriptural Karmakala Windows", hi: "शास्त्रीय कर्मकाल", ta: "சாத்திர கர்மகால நேரங்கள்" },
  karmakala_sub: { en: "The classical day-divisions prescribed for Shraddha, puja and vrata rites.", hi: "श्राद्ध, पूजा एवं व्रत हेतु निर्दिष्ट शास्त्रीय दिन-विभाग।", ta: "ஸ்ராத்தம், பூஜை மற்றும் விரத சடங்குகளுக்காக விதிக்கப்பட்ட சாத்திர பகல்-பிரிவுகள்." },
  varjyam: { en: "Varjyam · Tyajya Kala", hi: "वर्ज्यम् · त्याज्य काल", ta: "வர்ஜியம் · தியாஜ்ய காலம்" },
  varjyam_sub: { en: "The inauspicious segment of the nakshatra to be avoided for new undertakings.", hi: "नक्षत्र का त्याज्य अंश — नवीन कार्यों हेतु वर्जित।", ta: "நட்சத்திரத்தின் தியாஜ்ய பகுதி — புதிய முயற்சிகளுக்குத் தவிர்க்கவும்." },
  siddhi_yoga: { en: "Siddhi Yogas", hi: "सिद्धि योग", ta: "சித்தி யோகங்கள்" },
  siddhi_sub: { en: "Auspicious overrides that accomplish objectives and neutralise minor calendar flaws.", hi: "शुभ योग जो कार्य सिद्ध करते एवं लघु पंचांग-दोषों का शमन करते हैं।", ta: "நோக்கங்களை நிறைவேற்றி சிறு பஞ்சாங்க குறைகளை நீக்கும் சுப யோகங்கள்." },
  unlock_premium: { en: "Unlock with Premium", hi: "प्रीमियम से अनलॉक करें", ta: "பிரீமியத்துடன் திறக்கவும்" },
  premium_teaser: { en: "Subscribe to Panchangam Premium to reveal festival muhurtas, scriptural karmakala windows, Varjyam and Siddhi yogas for any date & place.", hi: "किसी भी तिथि एवं स्थान हेतु पर्व मुहूर्त, शास्त्रीय कर्मकाल, वर्ज्यम् एवं सिद्धि योग देखने हेतु पंचांग प्रीमियम लें।", ta: "எந்த தேதி மற்றும் இடத்திற்கும் பண்டிகை முகூர்த்தங்கள், கர்மகால நேரங்கள், வர்ஜியம் மற்றும் சித்தி யோகங்களைக் காண பஞ்சாங்கம் பிரீமியம் பெறுங்கள்." },
  significance: { en: "Significance", hi: "महत्त्व", ta: "முக்கியத்துவம்" },
  active_window: { en: "Active window", hi: "सक्रिय काल", ta: "செயல் நேரம்" },
  retry: { en: "Retry", hi: "पुनः प्रयास", ta: "மீண்டும் முயற்சி" },
  load_error: { en: "Could not reach the Panchangam engine.", hi: "पंचांग इंजन तक नहीं पहुँच सके।", ta: "பஞ்சாங்க இயந்திரத்தை அணுக முடியவில்லை." },
};

// ─────────────────────────  TELUGU (తెలుగు)  ─────────────────────────
export const TE_TITHI = {
  Pratipada: "పాడ్యమి", Dwitiya: "విదియ", Tritiya: "తదియ", Chaturthi: "చవితి", Panchami: "పంచమి",
  Shashthi: "షష్ఠి", Saptami: "సప్తమి", Ashtami: "అష్టమి", Navami: "నవమి", Dashami: "దశమి",
  Ekadashi: "ఏకాదశి", Dwadashi: "ద్వాదశి", Trayodashi: "త్రయోదశి", Chaturdashi: "చతుర్దశి", Purnima: "పౌర్ణమి", Amavasya: "అమావాస్య",
};
export const TE_PAKSHA = { Shukla: "శుక్ల", Krishna: "కృష్ణ" };
export const TE_NAKSHATRA = {
  Ashwini: "అశ్విని", Bharani: "భరణి", Krittika: "కృత్తిక", Rohini: "రోహిణి", Mrigashira: "మృగశిర", Mrigashirsha: "మృగశిర",
  Ardra: "ఆరుద్ర", Punarvasu: "పునర్వసు", Pushya: "పుష్యమి", Ashlesha: "ఆశ్లేష", Magha: "మఖ",
  "Purva Phalguni": "పుబ్బ", "Poorva Phalguni": "పుబ్బ", "Uttara Phalguni": "ఉత్తర", Hasta: "హస్త", Chitra: "చిత్త",
  Swati: "స్వాతి", Swathi: "స్వాతి", Vishakha: "విశాఖ", Anuradha: "అనూరాధ", Jyeshtha: "జ్యేష్ఠ", Jyeshta: "జ్యేష్ఠ",
  Mula: "మూల", Moola: "మూల", "Purva Ashadha": "పూర్వాషాఢ", "Poorva Ashadha": "పూర్వాషాఢ", "Uttara Ashadha": "ఉత్తరాషాఢ",
  Shravana: "శ్రవణం", Dhanishta: "ధనిష్ఠ", Shatabhisha: "శతభిషం", Shatabhishak: "శతభిషం",
  "Purva Bhadrapada": "పూర్వాభాద్ర", "Poorva Bhadrapada": "పూర్వాభాద్ర", "Uttara Bhadrapada": "ఉత్తరాభాద్ర", Revati: "రేవతి",
};
export const TE_YOGA = {
  Vishkambha: "విష్కంభ", Priti: "ప్రీతి", Ayushman: "ఆయుష్మాన్", Saubhagya: "సౌభాగ్య", Shobhana: "శోభన",
  Atiganda: "అతిగండ", Sukarma: "సుకర్మ", Sukarman: "సుకర్మ", Dhriti: "ధృతి", Shula: "శూల", Ganda: "గండ",
  Vriddhi: "వృద్ధి", Dhruva: "ధ్రువ", Vyaghata: "వ్యాఘాత", Harshana: "హర్షణ", Vajra: "వజ్ర", Siddhi: "సిద్ధి",
  Vyatipata: "వ్యతీపాత", Variyana: "వరీయాన్", Variyan: "వరీయాన్", Parigha: "పరిఘ", Shiva: "శివ", Siddha: "సిద్ధ",
  Sadhya: "సాధ్య", Shubha: "శుభ", Shukla: "శుక్ల", Brahma: "బ్రహ్మ", Indra: "ఐంద్ర", Aindra: "ఐంద్ర", Vaidhriti: "వైధృతి",
};
export const TE_KARANA = {
  Bava: "బవ", Balava: "బాలవ", Kaulava: "కౌలవ", Taitila: "తైతిల", Gara: "గరజ", Garaja: "గరజ", Vanija: "వణిజ",
  Vishti: "విష్టి", Bhadra: "విష్టి", Shakuni: "శకుని", Sakuni: "శకుని", Chatushpada: "చతుష్పాద", Chatushpad: "చతుష్పాద",
  Naga: "నాగ", Kimstughna: "కింస్తుఘ్న", Kintughna: "కింస్తుఘ్న",
};
export const TE_RASHI = {
  Mesha: "మేషం", Vrishabha: "వృషభం", Vrisha: "వృషభం", Mithuna: "మిథునం", Karka: "కర్కాటకం", Kark: "కర్కాటకం",
  Simha: "సింహం", Kanya: "కన్య", Tula: "తుల", Vrishchika: "వృశ్చికం", Vrischika: "వృశ్చికం",
  Dhanu: "ధనుస్సు", Dhanus: "ధనుస్సు", Makara: "మకరం", Makar: "మకరం", Kumbha: "కుంభం", Meena: "మీనం", Mina: "మీనం",
};
export const TE_VARA = {
  Ravivara: "ఆదివారం", Somavara: "సోమవారం", Mangalavara: "మంగళవారం", Budhavara: "బుధవారం",
  Guruvara: "గురువారం", Brihaspativara: "గురువారం", Shukravara: "శుక్రవారం", Shanivara: "శనివారం",
};
export const TE_MASA = {
  Chaitra: "చైత్రం", Vaishakha: "వైశాఖం", Vaisakha: "వైశాఖం", Jyeshtha: "జ్యేష్ఠం", Jyaistha: "జ్యేష్ఠం",
  Ashadha: "ఆషాఢం", Ashadh: "ఆషాఢం", Shravana: "శ్రావణం", Shraavana: "శ్రావణం",
  Bhadrapada: "భాద్రపదం", Bhaadrapada: "భాద్రపదం", Ashwin: "ఆశ్వయుజం", Ashwina: "ఆశ్వయుజం", Ashvin: "ఆశ్వయుజం",
  Kartika: "కార్తీకం", Kartik: "కార్తీకం", Margashirsha: "మార్గశిరం", Margashira: "మార్గశిరం",
  Pausha: "పుష్యం", Paush: "పుష్యం", Magha: "మాఘం", Maagha: "మాఘం", Phalguna: "ఫాల్గుణం", Phalgun: "ఫాల్గుణం",
};
export const TE_RITU = {
  Vasanta: "వసంత", Grishma: "గ్రీష్మ", Greeshma: "గ్రీష్మ", Varsha: "వర్ష",
  Sharad: "శరద్", Sharada: "శరద్", Hemanta: "హేమంత", Shishira: "శిశిర", Sisira: "శిశిర",
};
export const TE_DEITY = {
  Surya: "సూర్యుడు", Shiva: "శివుడు", Hanuman: "ఆంజనేయుడు", Vishnu: "విష్ణువు", Brihaspati: "బృహస్పతి",
  Lakshmi: "లక్ష్మి", Shani: "శని", Agni: "అగ్ని", Brahma: "బ్రహ్మ", Gauri: "గౌరి", Ganesha: "వినాయకుడు", Ganesh: "వినాయకుడు",
  Naga: "నాగుడు", Nagas: "నాగులు", Kartikeya: "కుమారస్వామి", Durga: "దుర్గ", Yama: "యముడు",
  Vishvedeva: "విశ్వేదేవత", Vishvedevas: "విశ్వేదేవతలు", Wishwedevas: "విశ్వేదేవతలు", Kamadeva: "మన్మథుడు",
  Chandra: "చంద్రుడు", Soma: "చంద్రుడు", Moon: "చంద్రుడు", Pitru: "పితృదేవతలు", Pitris: "పితృదేవతలు",
  "Ashvini Kumaras": "అశ్విని దేవతలు", "Ashwini Kumaras": "అశ్విని దేవతలు", Ashvini: "అశ్విని దేవతలు", Ashwini: "అశ్విని దేవతలు",
  Prajapati: "ప్రజాపతి", Rudra: "రుద్రుడు", Aditi: "అదితి", Sarpas: "నాగులు", Bhaga: "భగుడు", Aryaman: "అర్యముడు",
  Savitr: "సవిత", Savita: "సవిత", Tvastar: "విశ్వకర్మ", Tvashtar: "విశ్వకర్మ", Vishvakarma: "విశ్వకర్మ", Vishwakarma: "విశ్వకర్మ",
  Vayu: "వాయువు", Mitra: "మిత్రుడు", Indra: "ఇంద్రుడు", Indrani: "ఇంద్రాణి", Nirriti: "నిరృతి", Apah: "జలం", Apas: "జలం", Water: "జలం",
  Varuna: "వరుణుడు", Pushan: "పూషుడు", Vasu: "వసువు", Vasus: "వసువులు", "Aja Ekapada": "అజ ఏకపాద", AjaEkapada: "అజ ఏకపాద",
  "Ahir Budhnya": "అహిర్బుధ్న్యుడు", Ahirbudhnya: "అహిర్బుధ్న్యుడు",
  Bhumi: "భూదేవి", Skanda: "కుమారస్వామి", Narayana: "నారాయణుడు", Savitri: "సావిత్రి",
  Vidhatri: "బ్రహ్మ", Vidhata: "బ్రహ్మ", Dhata: "ధాత", Dharma: "ధర్ముడు", Aditya: "ఆదిత్యుడు",
  Matri: "మాతృదేవతలు", Matrika: "మాతృదేవతలు", Hari: "విష్ణువు", Kali: "కాళి", Ahi: "నాగుడు", Guha: "కుమారస్వామి",
  Ashvins: "అశ్విని దేవతలు",
};

// Hindi (Devanagari) presiding-deity names — mirrors TA_DEITY/TE_DEITY keys so
// Hindi resolves every devata (including free-form "Adidevata (Pratyadidevata)"
// strings) without leaking English.
export const HI_DEITY = {
  Surya: "सूर्य", Shiva: "शिव", Hanuman: "हनुमान", Vishnu: "विष्णु", Brihaspati: "बृहस्पति",
  Lakshmi: "लक्ष्मी", Shani: "शनि", Agni: "अग्नि", Brahma: "ब्रह्मा", Gauri: "गौरी",
  Ganesha: "गणेश", Ganesh: "गणेश", Naga: "नाग", Nagas: "नाग", Sarpas: "नाग", Kartikeya: "कार्तिकेय",
  Durga: "दुर्गा", Yama: "यम", Vishvedeva: "विश्वेदेव", Vishvedevas: "विश्वेदेव", Vishwedevas: "विश्वेदेव",
  Kamadeva: "कामदेव", Chandra: "चन्द्र", Soma: "चन्द्र", Moon: "चन्द्र", Pitru: "पितृ", Pitris: "पितृ",
  "Ashvini Kumaras": "अश्विनी कुमार", "Ashwini Kumaras": "अश्विनी कुमार", Ashvini: "अश्विनी कुमार", Ashwini: "अश्विनी कुमार",
  Prajapati: "प्रजापति", Rudra: "रुद्र", Aditi: "अदिति", Bhaga: "भग", Aryaman: "अर्यमा",
  Savitr: "सविता", Savita: "सविता", Savitri: "सावित्री", Tvastar: "त्वष्टा", Tvashtar: "त्वष्टा",
  Vishvakarma: "विश्वकर्मा", Vishwakarma: "विश्वकर्मा", Vayu: "वायु", Mitra: "मित्र",
  Indra: "इन्द्र", Indrani: "इन्द्राणी", Nirriti: "निऋति", Apah: "जल", Apas: "जल", Water: "जल",
  Varuna: "वरुण", Pushan: "पूषन्", Vasu: "वसु", Vasus: "वसु",
  "Aja Ekapada": "अज एकपाद", AjaEkapada: "अज एकपाद", "Ahir Budhnya": "अहिर्बुध्न्य", Ahirbudhnya: "अहिर्बुध्न्य",
  Bhumi: "भूमि", Skanda: "स्कन्द", Narayana: "नारायण",
  Vidhatri: "विधाता", Vidhata: "विधाता", Dhata: "धाता", Dharma: "धर्म", Aditya: "आदित्य",
  Matri: "मातृ", Matrika: "मातृका", Hari: "विष्णु", Kali: "काली", Ahi: "नाग", Guha: "गुह",
  Ashvins: "अश्विनी कुमार",
};

// Hindi (Devanagari) season names.
export const HI_RITU = {
  Vasanta: "वसन्त", Grishma: "ग्रीष्म", Greeshma: "ग्रीष्म", Varsha: "वर्षा",
  Sharad: "शरद", Sharada: "शरद", Hemanta: "हेमन्त", Shishira: "शिशिर", Sisira: "शिशिर",
};
export const TE_HORA = {
  Surya: "సూర్యుడు", Chandra: "చంద్రుడు", Mangala: "అంగారకుడు", Budha: "బుధుడు", Guru: "గురువు", Shukra: "శుక్రుడు", Shani: "శని",
  Sun: "సూర్యుడు", Moon: "చంద్రుడు", Mars: "అంగారకుడు", Mercury: "బుధుడు", Jupiter: "గురువు", Venus: "శుక్రుడు", Saturn: "శని",
};
export const TE_HORA_NOTE = {
  Surya: "అధికారం, ఆరోగ్యం, ప్రభుత్వం", Sun: "అధికారం, ఆరోగ్యం, ప్రభుత్వం",
  Chandra: "ప్రయాణం, భావోద్వేగాలు, నీరు, గృహం", Moon: "ప్రయాణం, భావోద్వేగాలు, నీరు, గృహం",
  Mangala: "శక్తి, ధైర్యం, వివాదం", Mars: "శక్తి, ధైర్యం, వివాదం",
  Budha: "విద్య, వాణిజ్యం, సంభాషణ", Mercury: "విద్య, వాణిజ్యం, సంభాషణ",
  Guru: "జ్ఞానం, ఆచారాలు, సంపద", Jupiter: "జ్ఞానం, ఆచారాలు, సంపద",
  Shukra: "కళలు, ప్రేమ, ఐశ్వర్యం", Venus: "కళలు, ప్రేమ, ఐశ్వర్యం",
  Shani: "శ్రమ, క్రమశిక్షణ, ఆలస్యం", Saturn: "శ్రమ, క్రమశిక్షణ, ఆలస్యం",
};
// Telugu UI labels (mirrors every key in TA_UI).
export const TE_UI = {
  daily_almanac: "దినసరి పంచాంగం", panchanga: "పంచాంగం",
  compute_note: "ఖగోళపరంగా లెక్కించబడింది (Swiss Ephemeris / True Lahiri Ayanamsa) — శూన్య వాతావరణ వక్రీభవనంతో కఠినమైన జ్యామితీయ కేంద్ర-బింబ సూర్యోదయాన్ని ఉపయోగిస్తుంది. కనిపించే ఆప్టికల్ సూర్యోదయంపై ఆధారపడే వాణిజ్య యాప్‌లకు భిన్నంగా, ధర్మార్థ పంచాంగం సాంప్రదాయ సిద్ధాంత పద్ధతిని ఉపయోగించి వాతావరణ వక్రీకరణను తొలగిస్తుంది — ఫలితంగా సూర్యోదయం, సూర్యాస్తమయం, హోరలు మరియు ముహూర్తాలలో అత్యంత ఖచ్చితమైన ~3–4 నిమిషాల వ్యత్యాసం.",
  ayanamsa: "అయనాంశం",
  hero_subtitle: "వేద కాలపు ఐదు అంగాలు — తిథి, వారం, నక్షత్రం, యోగం మరియు కరణం. మీ ఖచ్చితమైన ప్రదేశానికి నిజ-సమయ మార్పు క్షణాలు, గ్రహ హోరలు మరియు శుభ ముహూర్తాలు లెక్కించబడ్డాయి.",
  date: "తేదీ", time: "సమయం", now: "ఇప్పుడు", location: "ప్రదేశం", paksha: "పక్షం", pitru_paksha: "పితృ పక్షం",
  open_guide: "గైడ్ తెరవండి", current_hora: "ప్రస్తుత హోర", day: "పగలు", night: "రాత్రి",
  windows_heading: "శుభ మరియు అశుభ కాలాలు", brahma: "బ్రహ్మ ముహూర్తం", brahma_tip: "నిద్రలేచి ధ్యానం చేయడానికి ఉత్తమ సమయం",
  abhijit: "అభిజిత్ ముహూర్తం", rahu: "రాహు కాలం", yama: "యమగండం", gulika: "గుళిక కాలం",
  vara: "వారం", tithi: "తిథి", nakshatra: "నక్షత్రం", yoga: "యోగం", karana: "కరణం",
  lunar_month: "చాంద్ర మాసం", amanta: "అమాంతం", purnimanta: "పూర్ణిమాంతం", moon: "చంద్రుడు", sun: "సూర్యుడు", rashi: "రాశి",
  moonrise: "చంద్రోదయం", moonset: "చంద్రాస్తమయం", sunrise: "సూర్యోదయం", sunset: "సూర్యాస్తమయం",
  moon_length: "చంద్ర కాలం", day_length: "పగటి కాలం", ritu: "ఋతువు", samvat: "సంవత్సరం", vikram: "విక్రమ", shaka: "శక",
  hora_timeline: "హోర కాలపట్టిక", hora_timeline_sub: "సూర్యోదయం నుండి తదుపరి సూర్యోదయం వరకు 24 గ్రహ హోరలు. శుభ హోరలో ముఖ్యమైన పనులు చేయండి.",
  q_strong: "బలమైన", q_favourable: "అనుకూల", q_alert: "జాగ్రత్త", q_caution: "హెచ్చరిక",
  day_part: "పగలు (సూర్యోదయం → సూర్యాస్తమయం)", night_part: "రాత్రి (సూర్యాస్తమయం → సూర్యోదయం)",
  choghadiya: "చౌఘడియా ముహూర్తం", choghadiya_sub: "పగలు ఎనిమిది, రాత్రి ఎనిమిది చౌఘడియాలు. ముఖ్యమైన పనులకు శుభ, అమృత, లాభ మరియు చర కాలాలను ఎంచుకోండి.",
  day_choghadiya: "పగటి చౌఘడియా", night_choghadiya: "రాత్రి చౌఘడియా",
  devata: "దేవత", next: "తదుపరి", pada: "పాదం", now_badge: "ఇప్పుడు", marked_dates: "గుర్తించిన ప్రత్యేక తేదీలు",
  polar_notice: "అర్ధరాత్రి సూర్యుడు / ధ్రువ రాత్రి — ఈ అత్యధిక అక్షాంశంలో సూర్యోదయ ఆధారిత సమయాలు (చౌఘడియా, హోర, ముహూర్తం) సుమారుగా ఉంటాయి.",
  premium_almanac: "శాస్త్రీయ పంచాంగం", premium_almanac_sub: "పండుగ ముహూర్తాలు, శాస్త్రీయ కర్మకాల సమయాలు, వర్జ్యం మరియు సిద్ధి యోగాలు — సాంప్రదాయ గ్రంథాల నుండి.",
  festival_hub: "పండుగ & పూజా సమయాలు", no_pujas: "ఈ తేదీకి ప్రత్యేక పండుగ కర్మలు జాబితా చేయబడలేదు.",
  karmakala: "శాస్త్రీయ కర్మకాల సమయాలు", karmakala_sub: "శ్రాద్ధం, పూజ మరియు వ్రత కర్మలకు విధించిన శాస్త్రీయ పగటి-విభాగాలు.",
  varjyam: "వర్జ్యం · త్యాజ్య కాలం", varjyam_sub: "కొత్త పనులకు వర్జించవలసిన నక్షత్ర త్యాజ్య భాగం.",
  siddhi_yoga: "సిద్ధి యోగాలు", siddhi_sub: "లక్ష్యాలను సాధించి చిన్న పంచాంగ దోషాలను తొలగించే శుభ యోగాలు.",
  unlock_premium: "ప్రీమియంతో అన్‌లాక్ చేయండి",
  premium_teaser: "ఏ తేదీ & ప్రదేశానికైనా పండుగ ముహూర్తాలు, కర్మకాల సమయాలు, వర్జ్యం మరియు సిద్ధి యోగాలను చూడటానికి పంచాంగం ప్రీమియం పొందండి.",
  significance: "ప్రాముఖ్యత", active_window: "క్రియాశీల సమయం", retry: "మళ్లీ ప్రయత్నించండి", load_error: "పంచాంగ ఇంజిన్‌ను చేరుకోలేకపోయాము.",
};
export const TA_UI_TA = Object.fromEntries(Object.entries(TA_UI).map(([k, v]) => [k, v.ta]));
export const TA_UI_EN = Object.fromEntries(Object.entries(TA_UI).map(([k, v]) => [k, v.en]));
export const TA_UI_HI = Object.fromEntries(Object.entries(TA_UI).map(([k, v]) => [k, v.hi]));

// Hindi (Devanagari) lunar-month defaults (mirrors panchangLive MASA).
export const HI_MASA = {
  Chaitra: "चैत्र", Vaishakha: "वैशाख", Vaisakha: "वैशाख", Jyeshtha: "ज्येष्ठ", Jyaistha: "ज्येष्ठ",
  Ashadha: "आषाढ़", Ashadh: "आषाढ़", Shravana: "श्रावण", Shraavana: "श्रावण",
  Bhadrapada: "भाद्रपद", Bhaadrapada: "भाद्रपद", Ashwin: "आश्विन", Ashwina: "आश्विन", Ashvin: "आश्विन",
  Kartika: "कार्तिक", Kartik: "कार्तिक", Margashirsha: "मार्गशीर्ष", Margashira: "मार्गशीर्ष",
  Pausha: "पौष", Paush: "पौष", Magha: "माघ", Maagha: "माघ", Phalguna: "फाल्गुन", Phalgun: "फाल्गुन",
};

// Per-language default maps used to pre-fill the admin editor & resolve the page.
// English term default = the romanised key itself (what the API returns); Hindi
// pulls from panchangMaps where available (else blank → page falls back to the
// live payload's Devanagari at runtime).
const idMap = (obj) => Object.fromEntries(Object.keys(obj).map((k) => [k, k]));
export const PANCHANG_EN_DEFAULTS = {
  tithi: idMap(TA_TITHI), paksha: idMap(TA_PAKSHA), nakshatra: idMap(TA_NAKSHATRA), yoga: idMap(TA_YOGA),
  karana: idMap(TA_KARANA), rashi: idMap(TA_RASHI), vara: idMap(TA_VARA), masa: idMap(TA_MASA),
  ritu: idMap(TA_RITU), deity: idMap(TA_DEITY), hora: idMap(TA_HORA), hora_note: idMap(TA_HORA_NOTE), ui: TA_UI_EN, words: {},
};
export const PANCHANG_HI_DEFAULTS = {
  tithi: TITHI, paksha: PAKSHA, nakshatra: NAKSHATRA, yoga: YOGA, karana: KARANA, rashi: RASHI, vara: VARA,
  masa: HI_MASA, ritu: HI_RITU, deity: HI_DEITY, hora: {}, hora_note: HI_HORA_NOTE, ui: TA_UI_HI, words: {},
};
export const PANCHANG_TE_DEFAULTS = {
  tithi: TE_TITHI, paksha: TE_PAKSHA, nakshatra: TE_NAKSHATRA, yoga: TE_YOGA, karana: TE_KARANA,
  rashi: TE_RASHI, vara: TE_VARA, masa: TE_MASA, ritu: TE_RITU, deity: TE_DEITY, hora: TE_HORA,
  hora_note: TE_HORA_NOTE, ui: TE_UI, words: {},
};

// Tamil font options for the Panchangam editor (loaded in index.html).
export const TA_FONTS = ["Noto Serif Tamil", "Noto Sans Tamil", "Mukta Malar", "Hind Madurai", "Catamaran", "Pavanam"];
// Telugu font options.
export const TE_FONTS = ["Noto Serif Telugu", "Noto Sans Telugu", "Ramabhadra", "Mallanna", "Gidugu", "Suranna"];

// Built-in default for a field in a given language.
export function fieldDefault(cat, key, lang) {
  const src = lang === "ta" ? PANCHANG_TA_DEFAULTS : lang === "te" ? PANCHANG_TE_DEFAULTS : lang === "hi" ? PANCHANG_HI_DEFAULTS : PANCHANG_EN_DEFAULTS;
  return (src[cat] || {})[key] || "";
}

// Normalise a stored override cell to { en?, hi?, ta? } ( legacy string ⇒ Tamil ).
export function ovCell(i18n, cat, key) {
  const v = i18n && i18n[cat] && i18n[cat][key];
  if (v == null) return {};
  return typeof v === "string" ? { ta: v } : v;
}

// Default (code) Tamil registry — categories admins can override. Every category
// (including `ui`) is a flat { key: tamilString } map, so admin overrides are
// always plain strings and never clobber the English/Hindi reference copy.
export const PANCHANG_TA_DEFAULTS = {
  tithi: TA_TITHI, paksha: TA_PAKSHA, nakshatra: TA_NAKSHATRA, yoga: TA_YOGA, karana: TA_KARANA,
  rashi: TA_RASHI, vara: TA_VARA, masa: TA_MASA, ritu: TA_RITU, deity: TA_DEITY, hora: TA_HORA,
  hora_note: TA_HORA_NOTE, ui: TA_UI_TA, words: {},
};

// Deep-merge admin overrides (from settings.panchang_tamil) over the defaults.
// For term categories the override value is a plain string; for `ui` it's { ta }.
export function mergeTamil(overrides = {}) {
  const out = {};
  for (const cat of Object.keys(PANCHANG_TA_DEFAULTS)) {
    out[cat] = { ...PANCHANG_TA_DEFAULTS[cat], ...(overrides[cat] || {}) };
  }
  return out;
}

// Merged name-lookup dict for free-form phrases (devata strings, "next" names).
export function taPhraseDict(ta) {
  return { ...ta.tithi, ...ta.paksha, ...ta.nakshatra, ...ta.yoga, ...ta.karana, ...ta.rashi, ...ta.vara, ...ta.masa, ...ta.ritu, ...ta.deity, ...ta.hora, ...(ta.words || {}) };
}

// Merged phrase dict for a target language (hi/ta/te), applying admin overrides
// on top of the built-in defaults. Used to translate devata / "next" phrases
// token-by-token. Admins can map ANY word via the custom `words` category, which
// wins over the built-in maps.
export function phraseDictFor(lang, i18n = {}) {
  const src = lang === "te" ? PANCHANG_TE_DEFAULTS : lang === "hi" ? PANCHANG_HI_DEFAULTS : PANCHANG_TA_DEFAULTS;
  const cats = ["tithi", "paksha", "nakshatra", "yoga", "karana", "rashi", "vara", "masa", "ritu", "deity", "hora", "planet", "label", "samvatsara", "words"];
  const out = {};
  cats.forEach((c) => Object.assign(out, src[c] || {}));
  cats.forEach((c) => Object.keys(i18n[c] || {}).forEach((k) => { const cell = ovCell(i18n, c, k); if (cell[lang]) out[k] = cell[lang]; }));
  return out;
}

// Translate a free-form English name-phrase (e.g. "Gauri (Apas)", "Shukla Dwitiya")
// into Tamil, token by token, leaving punctuation/parentheses intact.
export function taPhrase(str, dict) {
  if (!str) return "";
  return String(str).replace(/[A-Za-z][A-Za-z'’.-]*(?:\s+[A-Za-z'’.-]+)*/g, (m) => {
    const key = m.trim();
    if (dict[key]) return dict[key];
    return key.split(/\s+/).map((w) => dict[w] || w).join(" ");
  });
}

// Admin-editor metadata: ordered groups + a friendly English reference for each key.
export const TA_ADMIN_GROUPS = [
  { cat: "ui", label: "Interface labels", refType: "ui" },
  { cat: "vara", label: "Vara (weekdays)", refType: "key" },
  { cat: "tithi", label: "Tithi", refType: "key" },
  { cat: "paksha", label: "Paksha", refType: "key" },
  { cat: "nakshatra", label: "Nakshatra", refType: "key" },
  { cat: "yoga", label: "Yoga", refType: "key" },
  { cat: "karana", label: "Karana", refType: "key" },
  { cat: "rashi", label: "Rashi (zodiac)", refType: "key" },
  { cat: "masa", label: "Lunar months (Masa)", refType: "key" },
  { cat: "ritu", label: "Ritu (seasons)", refType: "key" },
  { cat: "deity", label: "Presiding deities (Devata)", refType: "key" },
  { cat: "hora", label: "Hora (planets)", refType: "key" },
  { cat: "karmakala", label: "Karmakala windows (festival rites)", refType: "key" },
  { cat: "planet", label: "Grahas (planet names)", refType: "key" },
  { cat: "samvatsara", label: "Samvatsara (60-year cycle · Sauramana)", refType: "key" },
  { cat: "label", label: "Chart labels (Lord, House, Nakshatra…)", refType: "key" },
  { cat: "hora_note", label: "Hora descriptors", refType: "en" },
];


// ── Graha (planets), Samvatsara (60-year cycle) & common labels ──────────────
// English keys mirror what the engine returns. Used by the premium app so the
// Kundali / Dasha / Panchangam show a single clean language (no mixed text).
export const PLANET_HI = {
  Sun: "सूर्य", Moon: "चन्द्र", Mars: "मंगल", Mercury: "बुध", Jupiter: "गुरु", Venus: "शुक्र",
  Saturn: "शनि", Rahu: "राहु", Ketu: "केतु", Lagna: "लग्न", Ascendant: "लग्न", "Lagna (Asc)": "लग्न",
};
export const PLANET_TA = {
  Sun: "சூரியன்", Moon: "சந்திரன்", Mars: "செவ்வாய்", Mercury: "புதன்", Jupiter: "குரு", Venus: "சுக்கிரன்",
  Saturn: "சனி", Rahu: "ராகு", Ketu: "கேது", Lagna: "லக்னம்", Ascendant: "லக்னம்", "Lagna (Asc)": "லக்னம்",
};
export const LABEL_HI = { Favourable: "शुभ", Caution: "सावधानी", Neutral: "सामान्य", Lord: "स्वामी", House: "भाव", Retrograde: "वक्री", Pada: "पाद", Nakshatra: "नक्षत्र", Degree: "अंश", Rashi: "राशि" };
export const LABEL_TA = { Favourable: "சுபம்", Caution: "எச்சரிக்கை", Neutral: "சாதாரணம்", Lord: "அதிபதி", House: "பாவம்", Retrograde: "வக்ரம்", Pada: "பாதம்", Nakshatra: "நட்சத்திரம்", Degree: "பாகை", Rashi: "ராசி" };

// 60 Samvatsara (Jovian year) names — the engine's `samvat.sauramana`.
const SAMV = ["Prabhava","Vibhava","Shukla","Pramoda","Prajapati","Angirasa","Shrimukha","Bhava","Yuva","Dhatri","Ishvara","Bahudhanya","Pramadi","Vikrama","Vrisha","Chitrabhanu","Svabhanu","Tarana","Parthiva","Vyaya","Sarvajit","Sarvadhari","Virodhi","Vikriti","Khara","Nandana","Vijaya","Jaya","Manmatha","Durmukhi","Hevilambi","Vilambi","Vikari","Sharvari","Plava","Shubhakrit","Shobhakrit","Krodhi","Vishvavasu","Parabhava","Plavanga","Kilaka","Saumya","Sadharana","Virodhakrit","Paridhavi","Pramadicha","Ananda","Rakshasa","Nala","Pingala","Kalayukti","Siddharthi","Raudra","Durmati","Dundubhi","Rudhirodgari","Raktakshi","Krodhana","Akshaya"];
const SAMV_HI = ["प्रभव","विभव","शुक्ल","प्रमोद","प्रजापति","अंगिरस","श्रीमुख","भाव","युव","धातृ","ईश्वर","बहुधान्य","प्रमादी","विक्रम","वृष","चित्रभानु","स्वभानु","तारण","पार्थिव","व्यय","सर्वजित्","सर्वधारी","विरोधी","विकृति","खर","नन्दन","विजय","जय","मन्मथ","दुर्मुखी","हेविलम्बी","विलम्बी","विकारी","शार्वरी","प्लव","शुभकृत्","शोभकृत्","क्रोधी","विश्वावसु","पराभव","प्लवंग","कीलक","सौम्य","साधारण","विरोधकृत्","परिधावी","प्रमादीच","आनन्द","राक्षस","नल","पिंगल","कालयुक्ति","सिद्धार्थी","रौद्र","दुर्मति","दुन्दुभि","रुधिरोद्गारी","रक्ताक्षी","क्रोधन","अक्षय"];
const SAMV_TA = ["பிரபவ","விபவ","சுக்ல","பிரமோத","பிரஜாபதி","அங்கிரச","ஸ்ரீமுக","பவ","யுவ","தாத்ரு","ஈஸ்வர","பகுதான்ய","பிரமாதி","விக்கிரம","விருஷ","சித்ரபானு","சுபானு","தாரண","பார்த்திவ","வ்யய","சர்வஜித்","சர்வதாரி","விரோதி","விக்ருதி","கர","நந்தன","விஜய","ஜய","மன்மத","துர்முகி","ஹேவிளம்பி","விளம்பி","விகாரி","சார்வரி","பிலவ","சுபக்ருத்","சோபக்ருத்","குரோதி","விஸ்வாவசு","பராபவ","பிலவங்க","கீலக","சௌம்ய","சாதாரண","விரோதக்ருத்","பரிதாவி","பிரமாதீச","ஆனந்த","ராட்சச","நள","பிங்கள","காளயுக்தி","சித்தார்த்தி","ரௌத்ர","துர்மதி","துந்துபி","ருதிரோத்காரி","ரக்தாட்சி","குரோதன","அட்சய"];
const zipMap = (ks, vs) => Object.fromEntries(ks.map((k, i) => [k, vs[i]]));
export const SAMVATSARA_HI = zipMap(SAMV, SAMV_HI);
export const SAMVATSARA_TA = zipMap(SAMV, SAMV_TA);

// Register the new categories on the per-language default registries so
// phraseDictFor() picks them up (and admins can override them later).
PANCHANG_HI_DEFAULTS.planet = PLANET_HI;
PANCHANG_HI_DEFAULTS.label = LABEL_HI;
PANCHANG_HI_DEFAULTS.samvatsara = SAMVATSARA_HI;
PANCHANG_TA_DEFAULTS.planet = PLANET_TA;
PANCHANG_TA_DEFAULTS.label = LABEL_TA;
PANCHANG_TA_DEFAULTS.samvatsara = SAMVATSARA_TA;
// English registry = identity (the key itself is the English word) so the admin
// editor shows a sensible English placeholder and EN overrides can be saved.
const _idMap = (ks) => Object.fromEntries(ks.map((k) => [k, k]));
PANCHANG_EN_DEFAULTS.planet = _idMap(Object.keys(PLANET_HI));
PANCHANG_EN_DEFAULTS.label = _idMap(Object.keys(LABEL_HI));
PANCHANG_EN_DEFAULTS.samvatsara = _idMap(SAMV);

// ── Karmakala windows (scriptural day-divisions) ─────────────────────────────
// Keyed by the engine's stable object keys (pratah, madhyahna, …) so lookups are
// never broken by diacritics in the display name. Admin-editable via Panchangam
// Editor → "Karmakala windows".
export const KARMAKALA_EN = { pratah: "Prātaḥ Kāla", sangava: "Saṅgava Kāla", madhyahna: "Madhyāhna Kāla", aparahna: "Aparāhna Kāla", sayahna: "Sāyāhna Kāla", pradosha: "Pradoṣa Kāla", nishitha: "Niśītha Kāla", arunodaya: "Aruṇodaya Kāla" };
export const KARMAKALA_HI = { pratah: "प्रातः काल", sangava: "संगव काल", madhyahna: "मध्याह्न काल", aparahna: "अपराह्न काल", sayahna: "सायाह्न काल", pradosha: "प्रदोष काल", nishitha: "निशीथ काल", arunodaya: "अरुणोदय काल" };
export const KARMAKALA_TA = { pratah: "பிராத: காலம்", sangava: "சங்கவ காலம்", madhyahna: "மத்யாஹ்ன காலம்", aparahna: "அபராஹ்ன காலம்", sayahna: "சாயாஹ்ன காலம்", pradosha: "பிரதோஷ காலம்", nishitha: "நிசீத காலம்", arunodaya: "அருணோதய காலம்" };
export const KARMAKALA_TE = { pratah: "ప్రాతఃకాలం", sangava: "సంగవ కాలం", madhyahna: "మధ్యాహ్న కాలం", aparahna: "అపరాహ్ణ కాలం", sayahna: "సాయాహ్న కాలం", pradosha: "ప్రదోష కాలం", nishitha: "నిశీథ కాలం", arunodaya: "అరుణోదయ కాలం" };
PANCHANG_EN_DEFAULTS.karmakala = KARMAKALA_EN;
PANCHANG_HI_DEFAULTS.karmakala = KARMAKALA_HI;
PANCHANG_TA_DEFAULTS.karmakala = KARMAKALA_TA;
PANCHANG_TE_DEFAULTS.karmakala = KARMAKALA_TE;

// Build a single English→selected-language translator that reuses phraseDictFor
// (so admin overrides + custom `words` apply everywhere). For English we still
// apply the admin custom `words` overrides (en slot) so corrections/spellings
// entered in the Panchangam Editor take effect even on the default language.
// The engine returns Western sign names ("Libra") and paired labels
// ("चन्द्र · Chandra"). Reduce both to the single Sanskrit key the dictionaries
// use, so every language shows one name only (EN "Tula", HI "तुला", TA "துலாம்").
const WESTERN_RASHI = { Aries: "Mesha", Taurus: "Vrishabha", Gemini: "Mithuna", Cancer: "Karka", Leo: "Simha", Virgo: "Kanya", Libra: "Tula", Scorpio: "Vrishchika", Sagittarius: "Dhanu", Capricorn: "Makara", Aquarius: "Kumbha", Pisces: "Meena" };
const DEVA_RE = /[\u0900-\u097F]/;
export function normalizeEngineName(s) {
  let out = String(s).trim();
  const parts = out.split(" · ");
  if (parts.length === 2) {
    const [a, b] = parts.map((p) => p.trim());
    if (DEVA_RE.test(a) && !DEVA_RE.test(b)) out = b;
    else if (DEVA_RE.test(b) && !DEVA_RE.test(a)) out = a;
  }
  return WESTERN_RASHI[out] || out;
}

export function makePanchangT(lang, overrides = {}) {
  if (!lang || lang === "en") {
    const enMap = {};
    Object.keys(overrides?.words || {}).forEach((k) => {
      const cell = ovCell(overrides, "words", k);
      if (cell.en) enMap[k] = cell.en;
    });
    if (!Object.keys(enMap).length) return (s) => (s == null || s === "" ? s : normalizeEngineName(s));
    return (s) => (s == null || s === "" ? s : taPhrase(normalizeEngineName(s), enMap));
  }
  const dict = phraseDictFor(lang, overrides);
  return (s) => (s == null || s === "" ? s : taPhrase(normalizeEngineName(s), dict));
}
